import type { ActivityItem } from "./state.svelte.js";

// A task's feed card id: its "assigned you" row and its "updated your task" row are two cards, so a
// board move never hides the assigned row's due date, priority and source.
export function taskCardId(eventType: string, taskId: string): string {
  return eventType === "task_status_changed" ? `task-update:${taskId}` : `task:${taskId}`;
}

// One of this task's cards: its own, or a batch row that lists it among its tasks.
export function isTaskCardFor(
  i: Pick<ActivityItem, "id" | "sourceId" | "tasks">,
  taskId: string,
): boolean {
  if (!i.id.startsWith("task:") && !i.id.startsWith("task-update:")) return false;
  return i.sourceId === taskId || !!i.tasks?.some((t) => t.id === taskId);
}
